<p class="title">
    <img class="icon-title" src="assets/images/edit.svg" alt="Image" />
    {{ texts.titulo }}
</p>
<div class="container">
    <div id="mainDiv" class="main-div form-div">
        <div class="form-row">
            <div class="input-group">
                <label>{{ labels.id }}</label>
                <input type="text" pInputText [placeholder]="placeholders.nome_do_estado" [(ngModel)]="form.id" />
            </div>
            <div class="input-group">
                <label>{{ labels.nome }}</label>
                <input type="text" pInputText [placeholder]="placeholders.nome_do_estado" [(ngModel)]="form.nome" />
            </div>
        </div>
        <div class="form-row">
            <div class="input-group">
                <label>{{ labels.codigo_fatura_eletronica }}</label>
                <input type="number" pInputText [placeholder]="placeholders.codigo_fatura_eletronica"
                    [(ngModel)]="form.codigoFaturaEletronica" />
            </div>
            <div class="input-group">
                <label>{{ labels.pais }}</label>
                <p-dropdown id="selecionarPerfil" [options]="paises" optionLabel="label" dataKey="value" [placeholder]="placeholders.selecione"
                    [(ngModel)]="form.pais" appendTo="body">
                  <ng-template pTemplate="selectedItem" let-pais>
                    <div class="dropdown-pais-item" *ngIf="pais">
                      <img [src]="pais.flagUrl" class="flag-icon-small" alt="" />
                      <span>{{ pais.label }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="item" let-pais>
                    <div class="dropdown-pais-item">
                      <img [src]="pais.flagUrl" class="flag-icon-small" alt="" />
                      <span>{{ pais.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="actions-container">
            <button pButton [label]="botoes.atualizar" icon="pi pi-check" (click)="submit()" class="btn-primary"></button>
        </div>
    </div>
</div>
